<template>
  <div id="primary-insurance">
    <div class="primary-insurance-view">
      <div class="step-inner-navbar"></div>
      <div class="step-inner-content">
        <div class="vue-form">
          <el-form v-model="primaryInsuranceForm">
            <el-row :gutter="15">
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Relationship
                      <span class="star">*</span>
                    </label>
                    <el-select
                      v-model="primaryInsuranceForm.relationship"
                      @change="fillPrimaryDetails()"
                      @clear="clearNameSerach"
                      placeholder="Select Relationship"
                      filterable
                      clearable
                      default-first-option
                      
                    >
                      <el-option
                        v-for="(type, index) in relationships"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.relationship"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Plan Type
                    </label>
                    <el-select
                      placeholder="Select Plan Type"
                      v-model="primaryInsuranceForm.plan_type"
                      filterable
                      default-first-option
                      
                    >
                      <el-option
                        v-for="(type, index) of planTypes"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.plan_type"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      First Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.first_name"
                      placeholder="Enter First Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.first_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text"> Middle Name </label>
                    <el-input
                      v-model="primaryInsuranceForm.middle_name"
                      placeholder="Enter Middle Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.middle_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Last Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.last_name"
                      placeholder="Enter Last Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.last_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input gender-group">
                  <el-form-item class="mb-0">
                    <label for="text"> Gender <span class="star">*</span> </label>
                    <el-select
                      v-model="primaryInsuranceForm.gender"
                      placeholder="Select Gender"
                      filterable
                      default-first-option
                      
                      clearable
                    >
                      <el-option
                        v-for="(gender, index) in genderOptions"
                        :key="index"
                        :label="gender"
                        :value="gender"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.gender"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="date-of-birth case-creation__input">
                  <dobVersion
                    v-if="showPatientDob"
                    :dobData="primaryInsuranceForm"
                    :validataionErrors="getErrors"
                    :errorKey="'billing_info.insurance.primary_insurance.date_of_birth'"
                  >
                  </dobVersion>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <payor
                      v-if="show"
                      :payorData="primaryInsuranceForm"
                      :validataionErrors="getErrors"
                      :clearPayor="clearPayorData"
                      @payorSelect="fillInsurance"
                      insuranceType="primary_insurance"
                      @newInsuranceNameDetails="emitInsuranceDetails"
                      :billToInsurance="billTo"
                    >
                    </payor>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.payor"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Insurance Carrier Code <span class="star">*</span> </label>
                    <el-input
                      v-model="primaryInsuranceForm.insurance_carrier_code"
                      placeholder="Enter Insurance Carrier Code"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.insurance_carrier_code"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">
                      Policy No
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.policy_id"
                      placeholder="Enter Policy No"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.policy_id"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text">Group #</label>
                    <el-input
                      v-model="primaryInsuranceForm.group"
                      placeholder="Enter Group #"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.group"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text"> Address Line 1 <span class="star">*</span> </label>
                    <el-input
                      v-model="primaryInsuranceForm.address_line_1"
                      placeholder="Enter Address Line 1"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.address_line_1"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text"> Address Line 2 </label>
                    <el-input
                      v-model="primaryInsuranceForm.address_line_2"
                      placeholder="Enter Address Line 2"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.address_line_2"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <label for="text"> Zip <span class="star">*</span> </label>
                    <el-input
                      v-model="primaryInsuranceForm.zip"
                      placeholder="Enter Zip"
                      maxlength="5"
                      @input="getStateCity"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.zip"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <state
                      :stateData="primaryInsuranceForm"
                    ></state>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.state"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item class="mb-0">
                    <city
                      :cityData="primaryInsuranceForm"
                      v-if="show"
                    ></city>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.city"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

import caseConstants from "@/config/constants/caseConstants";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
const payor = defineAsyncComponent(() => import("@/components/misc/Payor"));
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
const state = defineAsyncComponent(() =>
  import("@/components/misc/BillingState")
);
const city = defineAsyncComponent(() =>
  import("@/components/misc/BillingCity")
);
import AppHelper from "@/mixins/AppHelper";
import InsuranceHelper from "@/mixins/InsuranceHelper";

import { mapGetters } from "vuex";
import { ElMessageBox } from "element-plus";

export default {
  props: [
    "parentRefs",
    "primaryInsurance",
    "refreshDob",
    "physicianPecos",
    "state",
    "orderingPhysician",
    "billTo"
  ],
  data() {
    return {
      primaryInsuranceForm: JSON.parse(JSON.stringify(caseConstants.insurance)),
      relationships: caseConstants.BILLING_RELATIONSHIPS,
      planTypes: ["INDIVIDUAL", "FAMILY"],
      genderOptions: ["MALE", "FEMALE"],
      payorData: {},
      show: false,
      showPatientDob: false,
      caseId: "",
      clearPayorData: false,
      patientData: {},
      facilityState: "",
      stateCarrierMapping: caseConstants.stateCarrierMapping,
      stateMedicaidCarrierMapping: caseConstants.stateMedicaidCarrierMapping,
      stateAetnaMapping: caseConstants.stateAetnaMapping,
    };
  },
  components: {
    FormError,
    payor,
    dobVersion,
    state,
    city,
  },
  mixins: [AppHelper, InsuranceHelper],
  computed: {
    ...mapGetters("orders", ["getCaseInformation"]),
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("cases", ["getStateAndCity"]),
  },
  mounted() {
    this.fetchStates();
    this.show = true;
    this.showPatientDob = true;
    if (this.primaryInsurance) {
      this.primaryInsuranceForm = { ...this.primaryInsurance };
    }
    if (this.$route.params.order_id) {
      this.caseId = this.$route.params.order_id;
      this.checkCaseInfo();
      this.patientData = this.getCaseInformation.patient_info;
    }
    this.facilityState = this.state;
  },

  methods: {
    emitInsuranceDetails(data) {
      if (data && Object.keys(data).length > 0) {
        this.primaryInsuranceForm.insurance_carrier_code = "12345";
      }
    this.$emit("newInsuranceNameDetails", data); // <-- emit to NewOrder.vue
  },
    async getStateCity() {
      try {
        let params = {
          zip: this.primaryInsuranceForm.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.primaryInsuranceForm.state = this.getStateAndCity.state;
          this.primaryInsuranceForm.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchStates() {
      await this.$store.dispatch("help/fetchAllStates");
    },
    getPrimaryInsuranceFormData() {
      return this.getFormattedValues(JSON.parse(JSON.stringify(this.primaryInsuranceForm)));
    },
    checkCaseInfo() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.billing_info &&
        this.getCaseInformation.billing_info.insurance &&
        this.getCaseInformation.billing_info.insurance.primary_insurance
      ) {
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getCaseInformation.billing_info.insurance.primary_insurance
        );
        this.payorData =
          this.getCaseInformation.billing_info.insurance.primary_insurance
            .payor || {};
      }
    },
    clearNameSerach() {
      this.primaryInsuranceForm = {
        relationship: "",
        plan_type: "",
        payor: "",
        insurance_code: "",
        gender: "",
        date_of_birth: "",
        policy_plan: "",
        group_or_plan: "",
        group: "",
        patient_policy: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zip: "",
        first_name: "",
        middle_name: "",
        last_name: "",
      };
      this.clearPayorData = true;
      setTimeout(() => {
        this.show = true;
      }, 100);
    },
    fillInsurance(data) {
       if (data && data.name == "Medicaid") {
        this.primaryInsuranceForm.payor = data.name;
        this.primaryInsuranceForm.insurance_carrier_code =
          this.stateMedicaidCarrierMapping[this.facilityState] || "";
      } else if (data && data.name == "Aetna") {
        this.primaryInsuranceForm.payor = data.name;
        this.primaryInsuranceForm.insurance_carrier_code =
          this.stateAetnaMapping[this.facilityState] || "";
      } else if (data) {
        this.primaryInsuranceForm.payor = data.name;
        if(data.name && data.name == 'CMS-MEDICARE' && this.checkColonyLab){
          this.primaryInsuranceForm.insurance_carrier_code = "SMTX0"
        } else if(data.name && data.name == 'CMS-MEDICARE' && this.isDLWLab){
          this.primaryInsuranceForm.insurance_carrier_code = "SMAL0"
        } else if (data.payor_electronic_id) {
          this.primaryInsuranceForm.insurance_carrier_code =
            data.payor_electronic_id;
        } else {
          this.primaryInsuranceForm.insurance_carrier_code = "";
        }
        const regex = /medicare/i;

        if (
          regex.test(this.primaryInsuranceForm.payor) &&
          this.orderingPhysician &&
          (this.physicianPecos === false || this.physicianPecos == null)
        ) {
          ElMessageBox.confirm(
            "Physician PECOS status is not verified. Do you want to proceed?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {})
            .catch(() => {});
        }
      }
    },
    fillPrimaryDetails() {
      this.clearPayorData = false;
      if (this.primaryInsuranceForm.relationship === "Self") {
        this.showPatientDob = false;
        let patientInformation =
          this.parentRefs && this.parentRefs.patientInformationForm
            ? this.parentRefs.patientInformationForm.formatPatientInfo()
            : this.patientData;
        this.primaryInsuranceForm.first_name = patientInformation.first_name;
        this.primaryInsuranceForm.middle_name = patientInformation.middle_name;
        this.primaryInsuranceForm.last_name = patientInformation.last_name;
        this.primaryInsuranceForm.gender = patientInformation.gender;

        this.primaryInsuranceForm.date_of_birth =
          patientInformation.date_of_birth;

        this.primaryInsuranceForm.city = patientInformation.city;
        this.primaryInsuranceForm.state = patientInformation.state;
        this.primaryInsuranceForm.zip = patientInformation.zip;
        this.primaryInsuranceForm.address_line_1 =
          patientInformation.address_line_1;
        this.primaryInsuranceForm.address_line_2 =
          patientInformation.address_line_2;

        setTimeout(() => {
          this.show = true;
          this.showPatientDob = true;
        });
      }
    },
  },
  watch: {
    refreshDob: {
      immediate: true,
      deep: true,
      handler: function () {
        this.showPatientDob = this.refreshDob;
      },
    },
    state: {
      immediate: true,
      deep: true,
      handler: function () {
        this.facilityState = this.state;
      },
    },
  },
};
</script>
